import { createContainer, createHook, createStore } from 'react-sweet-state';
const actions = {
  load: () => ({
    getState,
    setState
  }, {
    apiUtil
  }) => {
    if (!getState().loading) {
      setState({
        data: undefined,
        error: undefined,
        loading: true
      });
      apiUtil.jiraPost('/rest/gira/1/?operation=JiraProjects', {
        operationName: 'JiraProjects',
        query: 'query JiraProjects {\n' + '  allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {\n' + '    nodes {\n' + '      ...Project\n' + '      __typename\n' + '    }\n' + '    __typename\n' + '  }\n' + '}\n' + '\n' + 'fragment Project on JiraProject {\n' + '  id: projectId\n' + '  name\n' + '  avatar {\n' + '    large\n' + '    __typename\n' + '  }\n' + '  projectType\n' + '  simplified\n' + '  key\n' + '  __typename\n' + '}\n',
        variables: {}
      }).then(response => {
        setState({
          data: response.data.allProjects.nodes,
          loading: false
        });
      }).catch(apiError => {
        setState({
          error: apiError,
          loading: false
        });
      });
    }
  }
};
const Store = createStore({
  initialState: {
    data: undefined,
    error: undefined,
    loading: false
  },
  actions,
  name: 'ProjectsService'
});
export const ProjectsServiceContainer = createContainer(Store, {
  onInit: () => ({
    dispatch
  }) => dispatch(actions.load())
});
export const useProjectsService = createHook(Store);